// extracted by mini-css-extract-plugin
export var standaloneTable = "_f9-0";
export var standaloneTableWithBodyFill = "_f9-1";
export var withExtraHeader = "_f9-2";